import * as React from 'react';
import { Facility } from '../../Common/Services/Facility';
import { resolve, reject } from "q";
import { Utils } from '../../Common/Utilis';
import { Spinner } from 'react-bootstrap';

export default class LocationHistoryBox extends React.Component<any, any> {
    private scrollToBottomlist: any;
    constructor(props: any) {
        super(props);
        // this.scrollToBottomlist = React.createRef();
        this.state = {
            hotelid: this.props.hotelid,
            entryType: this.props.entryType,
            locationId: this.props.locationId,            
           // precommentlist: this.props.precommentlist,
            precommentlist:[],
            // value: '',
            // mentionData: null,
            // commentlist: [],
            // users: [],
            htmlHistory: [],
            // userComments: [],
            // logInUser: "",
            // logInUserImage: "",
            // isCommentAdd: false,
            // addCommentDisabled : this.props.addCommentDisabled,
            // workOrderName : this.props.parentState.parentRowData.name,
            allHistoryData: [], // Store full data
            visibleHistoryData: [], // Show paginated data
            initialLoadLimit: 0, // First load = 10 records
            nextLoadLimit: 30, // Next load = 20 records
            currentLimit: 0, 
            limit: 10, 
            isLoading: false,
        };
    }

   
    reloadHistory = () => {
      this.setState({ currentLimit: 0 });
      this.getHistoryLocation();
    }

    componentDidMount() {
        this.getHistoryLocation();
    }

    checkScrollPosition = () => {
      if (this.scrollToBottomlist) {
        const { scrollTop, scrollHeight, clientHeight } = this.scrollToBottomlist;
    
        if (scrollTop + clientHeight >= scrollHeight - 5) {
          this.loadMoreData();
        }
      }
    };
    
    loadMoreData = () => {

      if (this.state.isLoading || this.state.visibleHistoryData.length >= this.state.allHistoryData.length) {
        return;
      }
      this.setState({ isLoading: true });
      setTimeout(() => {
       
        const { allHistoryData, visibleHistoryData, currentLimit, nextLoadLimit,limit } = this.state;
        const newLimit = currentLimit == 0 ? limit : currentLimit + nextLoadLimit; // Increase the limit dynamically
    
        const nextRecords = allHistoryData.slice(visibleHistoryData.length, newLimit);
    
        if (nextRecords.length > 0) {
          this.setState(prevState => ({
            visibleHistoryData: [...prevState.visibleHistoryData, ...nextRecords],
            currentLimit: newLimit, // Update limit for next load
            isLoading: false,
          }));
        } else {
          this.setState({ isLoading: false });
        }
      }, 500);
    };
    getHistoryLocation()
    {
      let test = this.state.entryType;
      Facility.GetLocationHestoryDetails(this.state.hotelid,this.state.locationId)
        .then(async (result: any | null) => {          
          if (result != null && result.length > 0) {
            this.setState({
              allHistoryData: result,
              visibleHistoryData: result.slice(0, this.state.limit), 
              currentLimit: this.state.limit, 
            });
          } else {
            this.setState({ precommentlist: []});
          }
          resolve();
        })
        .catch((err) => {
          Utils.toastError(`Server Error, ${err}`, {
          });
  
        reject();
        });
    }
    loadPrevHistory() {
      const { precommentlist } = this.state;
      console.log(precommentlist);
    
      if (precommentlist.length > 0) {
        const itemComment = precommentlist.map((element,index) => {
          let message = "";
          switch (element.columnName) {
            case "CreatedLocation":
              message = `${element.createBy} created Location <b>${element.oldValue}</b>`;
              break;
            case "RoomStatus":
              message = `${element.createBy} changed Location Status from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "Notes":
              message = `${element.createBy} updated Location Notes: <b>${element.newValue}</b>`;
              break;
            case "LocationSubtype":
              message = `${element.createBy} changed Location Subtype from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "LocationType":
              message = `${element.createBy} changed Location Type from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "RoomName":
              message = `${element.createBy} changed Location Name from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
              case "Archived":
              message = `${element.createBy} Archived <b>${element.oldValue}</b>`;
              break;
              case "RestoreArchived":
              message = `${element.createBy} Restored <b>${element.newValue}</b> from <b>Archived</b>`;
              break;
              case "RenamedLocationType":
              message = `${element.createBy} renamed Location type from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
              case "Maintenance Add":
              message = `${element.createBy} added <b>${this.props.parentState.locationName || "None"}</b> to <b>${element.oldValue || "None"}</b>`;
              break;
              case "Maintenance Remove":
              message = `${element.createBy} removed <b>${this.props.parentState.locationName || "None"}</b> from <b>${element.oldValue || "None"}</b>`;
              break;
              case "Maintenance Status":
              message = `${element.createBy} updated <b>${element.additionalNotes || "None"}</b> : <b>${this.props.parentState.locationName || "None"}</b> from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
              case "Maintenance Skipped":
              message = `${element.createBy} skipped <b>${element.additionalNotes || "None"}</b> : <b>${this.props.parentState.locationName || "None"}</b> : ${element.oldValue || "None"}`;
              break;
              case "RenamedLocationSubType":
              message = `${element.createBy} renamed Location subtype from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            default:
              break;
          }
          const isLast = index === precommentlist.length - 1;
          return (
            <div key={element.ordered} className="timeline-item">
              <div className="timeline-dot"></div>
              {!isLast && <div className="timeline-line"></div>}
              <div className="timeline-content">
                <span className="timeline-date">
                  {element.modifyedDate}
                </span>
                <div
                  className="timeline-message"
                  dangerouslySetInnerHTML={{ __html: message }}
                ></div>
              </div>
            </div>
          );
        });
        this.setState({ htmlHistory: itemComment });
      }
    }

    render() {
      return (
        <div className="comment-box" ref={(ref) => (this.scrollToBottomlist = ref)}>
          <div className="comment-list">
            <ul>
              {this.state.visibleHistoryData.map((element, index) => {
                let message = "";
                // Apply the switch-case formatting
                switch (element.columnName) {
                  case "CreatedLocation":
                    message = `${element.createBy} created Location <b>${element.oldValue}</b>`;
                    break;
                  case "RoomStatus":
                    message = `${element.createBy} changed Location Status from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                  case "Notes":
                    message = `${element.createBy} updated Location Notes: <b>${element.newValue}</b>`;
                    break;
                  case "LocationSubtype":
                    message = `${element.createBy} changed Location Subtype from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                  case "LocationType":
                    message = `${element.createBy} changed Location Type from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                  case "RoomName":
                    message = `${element.createBy} changed Location Name from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                    case "Archived":
                    message = `${element.createBy} Archived <b>${element.oldValue}</b>`;
                    break;
                    case "RestoreArchived":
                    message = `${element.createBy} Restored <b>${element.newValue}</b> from <b>Archived</b>`;
                    break;
                    case "RenamedLocationType":
                    message = `${element.createBy} renamed Location type from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break; 
                    case "Maintenance Add":
                    message = `${element.createBy} added <b>${this.props.parentState.locationName || "None"}</b> to <b>${element.oldValue || "None"}</b>`;
                    break;
                    case "Maintenance Remove":
                    message = `${element.createBy} removed <b>${this.props.parentState.locationName || "None"}</b> from <b>${element.oldValue || "None"}</b>`;
                    break;
                    case "Maintenance Status":
                    message = `${element.createBy} updated <b>${element.additionalNotes || "None"}</b> : <b>${this.props.parentState.locationName || "None"}</b> from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                    case "Maintenance Skipped":
                    message = `${element.createBy} skipped <b>${element.additionalNotes || "None"}</b> : <b>${this.props.parentState.locationName || "None"}</b> : ${element.oldValue || "None"}`;
                    break;
                    case "RenamedLocationSubType":
                    message = `${element.createBy} renamed Location subtype from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                    break;
                  default:
                    break;
                }
    
                const isLast = index === this.state.visibleHistoryData.length - 1;

                return (
                  <div key={element.ordered} className="timeline-item">
                    <div className="timeline-dot"></div>
                    {!isLast && <div className="timeline-line"></div>}
                    <div className="timeline-content">
                      <span className="timeline-date">{element.modifyedDate}</span>
                      <div
                        className="timeline-message"
                        dangerouslySetInnerHTML={{ __html: message }}
                      ></div>
                    </div>
                  </div>
                );
              })}
            </ul>
          </div>
    
          {this.state.isLoading && (
            <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border"  size="sm" variant="secondary" />
              </div>
          )}{" "}
        </div>
      );
    }
}